import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';
import { ChecklistService } from 'src/app/services/checklist.service';

@Component({
  selector: 'app-workshop-jobcard-service-checklists',
  templateUrl: './workshop-jobcard-service-checklists.component.html',
  styleUrls: [
    './workshop-jobcard-service-checklists.component.scss',
    '../../workshop-jobcard-checklists/workshop-jobcard-pre-service-checks/workshop-jobcard-pre-service-checks.component.scss'
  ]
})
export class WorkshopJobcardServiceChecklistsComponent {

  @Input() jobcard: any;
  @Input() checklists: any[] = [];
  @Input() activeServiceTypeIDs: number[] = [];

  public loading: boolean = false;
  public updating: boolean = false;
  public preServiceChecklist: any = [];
  public mandatoryChecklist: any = [];
  public mandatoryBlockersChecklist: any = [];
  public linkedServiceChecklist: any = [];
  public additionalChecklist: any = [];
  public additionalChecklistMinimized: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private checklistService : ChecklistService
  ) { }

  ngOnInit() {
    this.generateGroups();
    console.log(this.jobcard);
  }

  generateGroups() {
    this.checklists.forEach(item => {
      // Normalise checkbox string values to booleans
      item.defaultValue = item.controlType === "CHECKBOX" && item.defaultValue === "false" ? false : item.controlType === "CHECKBOX" && item.defaultValue === "true" ? true : item.defaultValue;
      item.frontValue = item.controlType === "CHECKBOX" && item.frontValue === "false" ? false : item.controlType === "CHECKBOX" && item.frontValue === "true" ? true : item.frontValue;
      item.rearValue = item.controlType === "CHECKBOX" && item.rearValue === "false" ? false : item.controlType === "CHECKBOX" && item.rearValue === "true" ? true : item.rearValue;
    });

    // Only include checklists that are:
    //  (a) mandatory (always show), OR
    //  (b) mandatoryForAllServices (always show), OR
    //  (c) a pre-service or additional checklist that is explicitly enabled
    //      for at least one of the service types booked on this job card.
    // Items with linkedToServiceTypes=true but whose serviceTypeID is NOT in
    // activeServiceTypeIDs are excluded.
    const relevantChecklists = this.checklists.filter(x => {
      if (x.mandatory || x.mandatoryForAllServices) return true;
      if (this.activeServiceTypeIDs && this.activeServiceTypeIDs.length > 0) {
        // If the checklist carries a serviceTypeID, it must match one of the booked types
        if (x.serviceTypeID && x.serviceTypeID > 0) {
          return this.activeServiceTypeIDs.includes(x.serviceTypeID);
        }
        // Checklists with no serviceTypeID binding and not mandatory are excluded
        // when the job has specific service types selected (they would only show
        // when the service type configuration explicitly enables them)
        return false;
      }
      return true;
    });

    this.preServiceChecklist = relevantChecklists.filter(x => x.isPreServiceCheck && !x.mandatory);
    this.mandatoryChecklist = relevantChecklists.filter(x => x.mandatoryForAllServices && !x.mandatory);
    this.mandatoryBlockersChecklist = relevantChecklists.filter(x => x.mandatory);
    this.linkedServiceChecklist = relevantChecklists.filter(x => x.linkedToServiceTypes && !x.mandatory);
    this.additionalChecklist = relevantChecklists.filter(x => !x.isPreServiceCheck && !x.mandatoryForAllServices && !x.linkedToServiceTypes && !x.mandatory);

    // Optional: keep a consistent order in each group
    [this.preServiceChecklist, this.mandatoryChecklist, this.mandatoryBlockersChecklist, this.linkedServiceChecklist, this.additionalChecklist]
      .forEach((arr) => this.sortGroup(arr));

    if (this.preServiceChecklist.length === 0 && this.mandatoryChecklist.length === 0 && this.linkedServiceChecklist.length === 0) {
      this.additionalChecklistMinimized = false;
    }
  }

  sortGroup(array){
    array.sort((a: any, b: any) => {
      if (a.labelColour && b.labelColour) {
        return a.labelColour.localeCompare(b.labelColour);
      }
      return 0;
    }).sort((a: any, b: any) => {
      if (a.controlType && !b.controlType) {
        return -1;
      } else if (!a.controlType && b.controlType) {
        return 1;
      }
      return 0;
    });
  }

  done() {
    // Close with the original array that was passed in and mutated
    this.activeModal.close(this.checklists);
  }

  hasCheckedItems(): boolean {
    return this.checklists?.some((item: any) => {
      return item.controlType === 'CHECKBOX' && (item.defaultValue === true || item.frontValue === true || item.rearValue === true);
    });
  }

  getColor(colour: string): string {
    if (colour) {
      const hex = colour.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.2)`;
    } else {
      return 'rgba(0, 0, 0, 0.2)'; // Default color if no colour is provided
    }

  }

  isMandatoryChecklistComplete(){
    var isComplete = this.mandatoryBlockersChecklist.filter(item => item.defaultValue || item.rearValue || item.frontValue).length === this.mandatoryBlockersChecklist.length;
    return isComplete;
  }

  updateChecklistItem(item) {
    var data = {
      ServiceID: this.jobcard.id,
      ChecklistConfigID: item.id,
      DefaultValue: item.defaultValue,
      FrontValue: item.frontValue,
      RearValue: item.rearValue,
      ID: item.serviceChecklistID
    };
    this.checklistService.saveServiceChecklistValue(this.jobcard.partnerID, this.jobcard.id, data).subscribe(result => {
      //this.getChecklistService();
    });
  }
}